import BookCard from "./component/BookCard/BookCard";
import Header from "./component/Header/Header";
import "./App.css"
function App() {
  return (
    <div>
     <Header/>
     <BookCard/>
    </div>
  );
}

export default App;
